import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { MprcDialogTitleClose } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ITrainingRatingViewProps, TrainingRatingView } from "views/lms/student/TrainingRatingView/TrainingRatingView";

////////////////////////////////////////////////////////////////////////////

interface IProps extends ITrainingRatingViewProps {
    subtitle: React.ReactNode;
    onClose: (success?: boolean) => void;
}

////////////////////////////////////////////////////////////////////////////

export const TrainingRatingViewDialog: React.FC<IProps> = (props) => {
    const { t } = useTranslation("lms");
    const { onClose, subtitle } = props;

    return (
        <>
            <Dialog
                open
                fullWidth
                maxWidth="sm"
                onClose={() => onClose()}
            >
                <MprcDialogTitleClose
                    shrinkPadding
                    title={t("Student.TrainingRatingView.ViewTitle")}
                    subtitle={subtitle}
                    onClose={() => onClose()}
                />

                <DialogContent>
                    <TrainingRatingView {...props} />
                </DialogContent>
                <DialogActions>
                </DialogActions>
            </Dialog>
        </>
    );
};
